<template>
  <v-navigation-drawer v-bind="$attrs" v-on="$listeners" temporary app>
    <template v-slot:prepend>
      <v-list-item :to="{ name: 'Perfil' }" color="#711610" three-line>
        <v-list-item-avatar tile class="my-auto">
          <v-img
            :src="
              getUserInfo.fotoPerfil ? getUserInfo.fotoPerfil : getStaticProfile
            "
          ></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ getUserInfo.nombres }}</v-list-item-title>
          <v-list-item-title>{{ getUserInfo.apellidoPaterno }} {{getUserInfo.apellidoMaterno}}</v-list-item-title>
          <v-list-item-subtitle v-if="getUserInfo.carrera">
            {{
            getUserInfo.carrera.nombreEspecialidad
            }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
    </template>
    <v-list nav>
      <v-list-item v-for="(item, index) in items" :key="index" link :to="item.url">
        <v-list-item-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <template v-slot:append>
      <v-divider></v-divider>
      <div class="pa-2" :class="{'pb-12 mb-6': !$vuetify.breakpoint.mdAndUp}">
        <v-btn block dark color="#711610" @click="logout">
          <v-icon left>mdi-power-standby</v-icon>Cerrar Sesión
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'UserHomeDrawer',

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      visible: false
    }
  },

  methods: {
    ...mapActions('auth', ['logout'])
  },

  computed: {
    getStaticProfile() {
      return require('@/assets/anonymous.png')
    },

    ...mapGetters('user', ['getUserInfo', 'getError', 'fetching']),
  },
}
</script>
